import React from 'react';
import type { SiteType } from '../types';
import { PIN_FILL } from '../markers';

interface TypeMarkProps {
  type: SiteType;
}

const SHAPE: Record<SiteType, React.ReactNode> = {
  pit: <circle cx="6" cy="6" r="4.6" />,
  yard: <rect x="1.6" y="1.6" width="8.8" height="8.8" rx="2" />,
  rockfall: <polygon points="6,1.2 11,10.4 1,10.4" />,
};

/** The small site-type mark beside a name: the same shape and colour as the site's map pin. */
const TypeMark: React.FC<TypeMarkProps> = ({ type }) => (
  <svg
    viewBox="0 0 12 12"
    width="11"
    height="11"
    aria-hidden="true"
    className="tw-shrink-0"
    fill={PIN_FILL[type]}
    stroke="#0f172a"
    strokeWidth="1.2"
    strokeLinejoin="round"
  >
    {SHAPE[type]}
  </svg>
);

export default TypeMark;
